<template>
  <b-alert
    variant="danger"
    v-if="
      $store.state.profile.expiredAt &&
      new Date($store.state.profile.expiredAt) < Date.now()
    "
    dismissible
    fade
    :show="!isHide"
    @dismissed="isHide = true"
  >
    <div class="alert-body text-center">
      {{ $t("alert.yourAccountIsExpired") }}
    </div>
  </b-alert>
</template>

<script>
import { BAlert, BLink, BSpinner } from "bootstrap-vue";

export default {
  components: {
    BAlert,
    BLink,
    BSpinner,
  },
  data() {
    return {
      isHide: false,
    };
  },
};
</script>
